import { FC } from 'react';
import { Form, Select } from 'antd';
import { HealthProfessionDropdownContainerProps } from './health-profession-dropdown-container';
import { HealthProfession } from '../../../types/healthProfession';

interface HealthProfessionDropdownProps extends HealthProfessionDropdownContainerProps {}

export const HealthProfessionDropdown: FC<HealthProfessionDropdownProps> = (props) => {
  return (
    <Form.Item
    name={props.name}
    label={props.label ?? 'Select Health Profession'}
    rules={props.rules ?? []}
    >
      <Select placeholder={props.placeholder} style={props.style}>
      {props.allHealthProfessionData.map((item: HealthProfession) => (
        <Select.Option key={item.professionCode} value={item.professionCode}>
          {item.professionName}
        </Select.Option>
      ))}
    </Select>
    </Form.Item>
  );
};
